import React from "react";
import "./Contact.css";
import mobile from "../../assets/mobile.png";
import email from "../../assets/email.png";
import navigation from "../../assets/navigation.png";
import github from "../../assets/github.svg";
import instagram from "../../assets/instagram.svg";
import linkedin from "../../assets/linkedin.svg";
import { useTranslation } from "react-i18next";

const Contact = ({ id }) => {
  const { t } = useTranslation();

  return (
    <div id={id} className="contact-container">
      <div className="contact-title">
        <h1>{t("contact.title")}</h1>
      </div>

      <div className="contact-section">
        <div className="left">
          {/* <h1>Let's talk</h1> */}
          <p>{t("contact.text")}</p>

          {/* Yhteystiedot */}
          <div className="details">
            <div className="detail">
              <img src={email} alt="" />
              <p>sauli97@gmail.com</p>
            </div>
            <div className="detail">
              <img src={mobile} alt="" />
              <p>050 4959105</p>
            </div>
            <div className="detail">
              <img src={navigation} alt="" />
              <p>{t("contact.location")}</p>
            </div>
          </div>

          {/* Somet  */}
          <div className="socials">
            <div className="social">
              <img src={github} alt="GitHub logo" />
              <a
                href="https://github.com/Cyp6ty"
                target="_blank"
                rel="noopener noreferrer"
              >
                GitHub
              </a>
            </div>
            <div className="social">
              <img src={instagram} alt="Instagram logo" />
              <a
                href="https://www.instagram.com/ssaleee/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </div>
            <div className="social">
              <img src={linkedin} alt="LinkedIn logo" />
              <a
                href="https://www.linkedin.com/in/sauli-pitk%C3%A4kangas-89307b2a0/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </div>
          </div>
        </div>

        {/* Oikea puoli */}
        {/* <form className="form">
          <label forHtml="name">Name</label>
          <input type="text" placeholder="Enter your name" name="name" />

          <label forHtml="email">Email</label>
          <input type="email" placeholder="Enter your email" name="email" />

          <label forHtml="message">Message</label>
          <textarea
            name="message"
            rows="8"
            placeholder="Enter your message"
          ></textarea>

          <button className="contact-submit" type="submit">
            Send
          </button>
        </form> */}
        {/* <button>Send!</button> */}
      </div>
    </div>
  );
};

export default Contact;
